export function trimWithEllipsis(text,val=15) {
  return text.length > val ? text.slice(0, val) + '...' : text;
}